/**
 * WEiTSICHT – Veröffentlichungen Filter & Sortierung
 * Vanilla JavaScript – keine Abhängigkeiten
 */
(function () {
  'use strict';

  const SELECTORS = {
    grid: '#voe-grid',
    card: '.voe-card',
    filterBtn: '.voe-filter-btn',
    sortSelect: '#voe-sort-select',
    noResults: '#voe-no-results',
    count: '#voe-count',
  };

  const CLASSES = {
    hidden: 'voe-hidden',
    active: 'voe-filter-btn--active',
    animateIn: 'voe-animate-in',
  };

  let currentFilter = 'alle';
  let currentSort = 'datum-desc';

  function init() {
    const grid = document.querySelector(SELECTORS.grid);
    if (!grid) return;

    bindFilterButtons();
    bindSortSelect();
    applySort(); // Initial sort
  }

  /* ---- Filter ---- */
  function bindFilterButtons() {
    document.querySelectorAll(SELECTORS.filterBtn).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.getAttribute('data-filter');
        if (filter === currentFilter) return;

        currentFilter = filter;

        // Update active state
        document.querySelectorAll(SELECTORS.filterBtn).forEach(function (b) {
          b.classList.remove(CLASSES.active);
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add(CLASSES.active);
        this.setAttribute('aria-selected', 'true');

        applyFilter();
        updateCount();
      });
    });
  }

  function applyFilter() {
    var cards = document.querySelectorAll(SELECTORS.card);
    var delay = 0;

    cards.forEach(function (card) {
      var platform = card.getAttribute('data-platform') || '';
      var show = currentFilter === 'alle' || platform === currentFilter;

      if (show) {
        card.classList.remove(CLASSES.hidden);
        card.classList.remove(CLASSES.animateIn);
        // Trigger reflow for animation
        void card.offsetWidth;
        card.style.animationDelay = delay + 'ms';
        card.classList.add(CLASSES.animateIn);
        delay += 60;
      } else {
        card.classList.add(CLASSES.hidden);
        card.classList.remove(CLASSES.animateIn);
      }
    });

    toggleNoResults();
  }

  /* ---- Sortierung ---- */
  function bindSortSelect() {
    var select = document.querySelector(SELECTORS.sortSelect);
    if (!select) return;

    select.addEventListener('change', function () {
      currentSort = this.value;
      applySort();
    });
  }

  function applySort() {
    var grid = document.querySelector(SELECTORS.grid);
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(SELECTORS.card));

    cards.sort(function (a, b) {
      switch (currentSort) {
        case 'datum-desc':
          return compareDates(b, a);
        case 'datum-asc':
          return compareDates(a, b);
        case 'titel-asc':
          return compareTitles(a, b);
        case 'titel-desc':
          return compareTitles(b, a);
        default:
          return 0;
      }
    });

    // Re-append in sorted order
    var fragment = document.createDocumentFragment();
    cards.forEach(function (card) {
      fragment.appendChild(card);
    });
    grid.appendChild(fragment);
  }

  function compareDates(a, b) {
    var dateA = a.getAttribute('data-datum') || '0000-00-00';
    var dateB = b.getAttribute('data-datum') || '0000-00-00';
    return dateA.localeCompare(dateB);
  }

  function compareTitles(a, b) {
    var titleA = a.getAttribute('data-titel') || '';
    var titleB = b.getAttribute('data-titel') || '';
    return titleA.localeCompare(titleB, 'de');
  }

  /* ---- Hilfsfunktionen ---- */
  function updateCount() {
    var countEl = document.querySelector(SELECTORS.count);
    if (!countEl) return;

    var visible = document.querySelectorAll(
      SELECTORS.card + ':not(.' + CLASSES.hidden + ')'
    ).length;
    countEl.textContent = visible;
  }

  function toggleNoResults() {
    var noResults = document.querySelector(SELECTORS.noResults);
    if (!noResults) return;

    var visible = document.querySelectorAll(
      SELECTORS.card + ':not(.' + CLASSES.hidden + ')'
    ).length;
    noResults.style.display = visible === 0 ? 'block' : 'none';
  }

  /* ---- Start ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
